<template>
  <svg
    class="gauge-graph"
    ref="graph"
  />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import { createGraph, GaugeGraph } from '@betterboards/graphs/index'
import { GraphTypes } from '@betterboards/graphs/types/Graph'
import { mapState } from 'vuex'
import { GaugeGraphConfig, GaugeGraphData } from '@betterboards/graphs/variants/GaugeGraph'

function DefaultData () {
  return {
    graph: undefined as undefined | GaugeGraph
  }
}

export default Vue.extend({
  name: 'GaugeGraph',
  props: {
    data: {
      type: Object as PropType<GaugeGraphData>,
      required: false
    },
    comparisonData: {
      type: Object as PropType<GaugeGraphData | undefined>,
      required: false
    },
    config: {
      type: Object as PropType<Partial<GaugeGraphConfig>>,
      required: false
    }
  },
  data: DefaultData,
  mounted (): void {
    this.renderGraph()
  },
  watch: {
    data: 'renderGraph',
    comparisonData: 'renderGraph',
    'user.defaultLanguage': 'renderGraph'
  },
  computed: {
    ...mapState('User', ['user']),
    scale (): number {
      if (this.config?.scale) {
        return this.config.scale
      }
      return 1
    },
    width (): number {
      if (this.config?.width) {
        return this.config.width
      }
      return 700
    },
    height (): number {
      if (this.config?.height) {
        return this.config.height
      }
      return 450
    }
  },
  methods: {
    renderGraph (): any {
      console.log('config', this.config)
      const config: Partial<GaugeGraphConfig> = {
        ...this.config,
        width: this.width,
        height: this.height
      }

      const graph = this.graph = createGraph<GraphTypes.Gauge>(GraphTypes.Gauge, this.$refs.graph as SVGElement, config)
      graph.render(this.data)
    }
  }
})
</script>

<style lang="scss">
.gauge-graph {
  display: block;
  margin: auto auto;
  width: auto;
  height: 100%;
}
</style>
